import { Box, Button, Dialog, DialogActions, DialogContent, Divider, FormControl, FormHelperText, Grid, IconButton, InputAdornment, makeStyles, Modal, Skeleton, styled, TextField, Theme, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { BlackExitIcon, CheckedRadio, PdfIcon, UncheckRadio } from '../../../assets/SvgIcons'
import { CustomeButton, CustomeModalDropDown } from '../../../lib/formik/NewFormInputs'
import { useFormik, FormikProvider, FormSchemaProvider } from '../../../lib/formik/Formik'
import * as Yup from 'yup';
import { GetMandateCreationDetailsResponseBody, GetMandateRegisteredResponseBody, MandateCreation } from '../../../redux-store/types/investorProfile'
import { useDispatch, useSelector } from 'react-redux'
import { getMandateCreationDetails, getMandateRegistered, } from '../../../redux-store/actions/investorProfile'
import { useHistory } from 'react-router'
import { fontSize } from '@mui/system'
import { RootStateType } from '../../../redux-store/reducers'
import { BANK_SUB_ACCOUNT_TYPES, NEXEDGE_MDMS_APIS } from '../../../utils/constant'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import CalendarIcon from '../../../assets/icons/CalendarIcon'
import dayjs from '../../../utils/dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { addYearsAndSubtractOneDay } from '../../../utils/utilityFunctions'
import { showError } from '../../../redux-store/actions/auth'

type Props = {
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
    setActiveTab?: React.Dispatch<React.SetStateAction<string>>
    title: string
    handleClose: () => void
    bankMandateDetails?: Array<MandateCreation>
    clientCode?: string
    mandateRequestDialog?: boolean,
    setMandateRequestDialog?: React.Dispatch<React.SetStateAction<boolean>>,
    mandateFormValues?: Partial<Values>,
    setMandateFormValues?: React.Dispatch<React.SetStateAction<Values>>,
    selectedRadio?: number,
    setSelectedRadio?: React.Dispatch<React.SetStateAction<number>>,
    radioList?: { id: number, label: string }[];
    handleSuccess?: () => void
}

interface Values {
    amount: string;
    accountNo: string;
    bankSubAccountType: string | null;
    ifscCode: string;
    bankName: string;
    startDate?: string;
    endDate?: string;
    acctType?: string;
    // months: string;
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '950px',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    borderRadius: '12px',
    // p: '24px',
    ':focus': {
        outline: 'none'
    },
}

// const radioList = [
//     {
//         id: 1,
//         label: 'XSIP',
//     },
//     {
//         id: 2,
//         label: 'E-Mandate',
//     }
// ]



const BankValidation = Yup.object().shape({
    amount: Yup.string().required('Amount is required'),
    accountNo: Yup.string().required('Required'),
    ifscCode: Yup.string().required('Required').transform((value) => {
        return value && value.toUpperCase()
    }),
    bankName: Yup
        .string()
        .nullable()
        .required('Bank Name is required')
        .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field "),
    // months: Yup.string()
    //     .required('Months field is required')
    //     .test("checkMonths", "Months should be from 6 to 480", function (value) {
    //         if (value) {
    //             return parseInt(value) >= 6 && parseInt(value) <= 480;
    //         }
    //         return true
    //     })
})


const initialData = {
    amount: '',
    accountNo: '',
    bankSubAccountType: '',
    ifscCode: '',
    bankName: '',
    startDate: '',
    endDate: '',
    acctType: '',
    // months: '',
}


const radioList = [
    {
        id: 1,
        label: 'XSIP',
    },
    {
        id: 2,
        label: 'E-Mandate',
    }
]

const MandateFormSkeleton = () => {
    return (
        <>
            <Box display="flex" flexDirection="row" gap="10px">
                {[1, 2].map((item) => (
                    <Skeleton
                        key={item}
                        variant="rectangular"
                        width={160}
                        height={40}
                        sx={{ borderRadius: "10px" }}
                    />
                ))}
            </Box>
            <Box
                sx={{
                    margin: "15px 0",
                    borderTop: "0.5px solid #CDCDCD",
                    borderBottom: "0.5px solid #CDCDCD",
                }}
            >
                <Grid container columnSpacing={4} rowSpacing="45px" padding="45px 0">
                    {[1, 2, 3, 4, 5, 6].map((item) => (
                        <Grid key={item} item lg={6} md={12} sm={12} xs={12}>
                            <Skeleton
                                variant="rectangular"
                                height={45}
                                sx={{ borderRadius: "10px" }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>

            <Box marginTop="25px" gap="25px" display="flex" flexDirection="column">
                <Box>
                    <Skeleton variant="text" width="100%" height={20} />
                    <Skeleton variant="text" width="100%" height={20} />
                </Box>

                <Box>
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={42}
                        sx={{ borderRadius: "8px" }}
                    />
                </Box>
            </Box>
        </>
    );
};

const AddBankModal = (props: Props) => {
    const { open, setOpen, title, setActiveTab, handleClose, clientCode, mandateRequestDialog, setMandateRequestDialog, mandateFormValues, handleSuccess } = props
    const theme = useTheme();
    const { palette } = useTheme()
    const dispatch = useDispatch()
    const { location: { pathname } } = useHistory()


    const [bankMandateDetails, setBankMandateDetailsRes] = useState<Array<MandateCreation>>([]);
    const [bankAccountNumbers, setBankNumber] = useState<Array<{ label: string, value: string }>>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [isFormSubmitting, setFormSubmitting] = useState<boolean>(false)
    const [dialogPopup, setDialogPopup] = useState<boolean>(false);
    const [registerMandateRes, setRegisterMandateRes] = useState({})
    const [selectedRadio, setSelectedRadio] = useState<number>(radioList[0].id);
    const { selectedPortfolio } = useSelector((state: RootStateType) => state.selectedPortfiolio)
    const { clientInterfaceCode } = useSelector((state: RootStateType) => state.id);



    const formik = useFormik({
        initialValues: initialData,
        onSubmit: handleFormSubmit,
        validationSchema: BankValidation,
        validateOnBlur: false,
        validateOnChange: false,
        enableReinitialize: true
    })
    const { handleChange, values, handleSubmit, handleBlur, setFieldValue, errors, validateOnChange, validateField } = formik


    const [startDate, setStartDate] = useState<string>(dayjs().format("YYYY-MM-DD"));
    const defaultEndingDate = addYearsAndSubtractOneDay(startDate, 40)
    const [endDate, setEndDate] = useState<string>(defaultEndingDate.format("YYYY-MM-DD"));

    const maxStartDatePossible = '2060-01-01'
    const fortyYrsFromNow = dayjs(startDate).add(40, 'year').format("YYYY-MM-DD");


    useEffect(() => {

        const fetchApi = async () => {

            try {
                setLoading(true);

                const res = await (dispatch(getMandateCreationDetails({ clientCode: clientCode, portfolioId: selectedPortfolio?.value })) as unknown as Promise<Array<MandateCreation>>);

                const bankMandateDetailsRes: GetMandateCreationDetailsResponseBody = {
                    "mandateCreationDetails": res
                }
                // console.log("BANK DETAILS RES", bankMandateDetailsRes);
                setBankMandateDetailsRes(bankMandateDetailsRes?.mandateCreationDetails);
                setFieldValue('ifscCode', bankMandateDetailsRes?.mandateCreationDetails[0]?.ifscCode)
                setFieldValue('bankName', bankMandateDetailsRes?.mandateCreationDetails[0]?.bankName)
                setFieldValue('accountNo', bankMandateDetailsRes?.mandateCreationDetails[0]?.bankAccountNumber)
                setFieldValue('acctType', bankMandateDetailsRes?.mandateCreationDetails[0]?.bankAccountType || '');
                setFieldValue('bankSubAccountType', bankMandateDetailsRes?.mandateCreationDetails[0]?.bankSubAccountType ?? "")

                setBankNumber(() => {
                    return bankMandateDetailsRes?.mandateCreationDetails?.map((item) => {
                        return {
                            label: `
                            ${item?.bankAccountNumber} 
                            ${BANK_SUB_ACCOUNT_TYPES[`${item?.bankSubAccountType ?? ""}`.toUpperCase()] ? "(" + BANK_SUB_ACCOUNT_TYPES[`${item?.bankSubAccountType ?? ""}`.toUpperCase()] + ")" : ""}
                            `,
                            value: item?.bankAccountNumber
                        }
                    })
                })

                setFieldValue('startDate', startDate);
                setFieldValue('endDate', endDate);

            } catch (e) {
                console.log("Error", e);
            } finally {
                setLoading(false);
            }
        }
        fetchApi();
    }, [])

    const handleModalDropdown = (name: string, value: string) => {
        // console.log("Value", value);
        setFieldValue("accountNo", value.toString());
        const filteredAccountNumbers = bankMandateDetails?.filter((account) => parseInt(account.bankAccountNumber) === parseInt(value));

        setFieldValue('bankName', filteredAccountNumbers?.[0]?.bankName)
        setFieldValue('ifscCode', filteredAccountNumbers?.[0]?.ifscCode)
        setFieldValue('acctType', filteredAccountNumbers?.[0]?.bankAccountType);
        setFieldValue('bankSubAccountType', filteredAccountNumbers?.[0]?.bankSubAccountType ?? "")
    };


    async function handleFormSubmit(value: Values) {
        // const actype = bankMandateDetails?.[0]?.bankAccountType === "SAVING" ? "1" : "2";
        // const actype = (values?.acctType?.toUpperCase() === "SAVING") ? "1" : "2";

        if (dayjs(value.endDate).isBefore(dayjs(value.startDate))) {
            dispatch(showError('End date should be greater than or equal to start date'))
        }
        else if (dayjs(value.endDate).isAfter(fortyYrsFromNow)) {
            dispatch(showError('End Date exceeds 40 years of maximum duration'))
        }
        else if (dayjs(value.startDate).isAfter(maxStartDatePossible)) {
            dispatch(showError('Start date should be less than or equal to 01 January 2060'))
        }

        const registerMandatePayload = {
            amount: value?.amount?.toString(),
            actype: value?.acctType ?? "",
            mandateType: selectedRadio === 1 ? "X" : "N",
            clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
            ifscCode: value?.ifscCode,
            accountNo: value?.accountNo,
            // months: parseInt(value?.months),
            bankName: value?.bankName,
            portfolioId: selectedPortfolio?.value,
            startDate: dayjs(value?.startDate).format("DD/MM/YYYY"),
            endDate: dayjs(value?.endDate).format("DD/MM/YYYY"),
            bankSubAccountType: value?.bankSubAccountType ?? ""
        }

        try {
            setFormSubmitting(true);
            const res = await (dispatch(getMandateRegistered(registerMandatePayload)) as unknown as Promise<GetMandateRegisteredResponseBody>);
            setRegisterMandateRes(res);
            if (res?.is_mandate_registered) {
                setDialogPopup(true);
            }
        } catch (e) {
            console.log("E", e);
        } finally {
            setFormSubmitting(false);
        }
    }

    // useEffect(() => {
    //     if (bankMandateDetails) {
    //         setFieldValue('ifscCode', bankMandateDetails[0]?.ifscCode)
    //         setFieldValue('bankName', bankMandateDetails[0]?.bankName)
    //         setFieldValue('accountNo', bankMandateDetails[0]?.bankAccountNumber)

    //     }
    // }, [bankMandateDetails])

    const handleOnChange = (name: string, value: string | number) => {
        setFieldValue(name, value);

        // if (name === 'endDate' && dayjs(value).isBefore(dayjs(startDate))) {
        //     setTimeout(() => {
        //         dispatch(showError('End date should be greater than or equal to start date'))
        //     }, 1000)
        // }
        if (name === 'endDate' && dayjs(value).isAfter(fortyYrsFromNow)) {
            setTimeout(() => {
                dispatch(showError('End Date exceeds 40 years of maximum duration'))
            }, 1000)
        }
        // else if (name === 'startDate' && dayjs(value).isAfter(maxStartDatePossible)) {
        //     setTimeout(() => {
        //         dispatch(showError('Start date should be less than or equal to 01 January 2060'))
        //     }, 1000)
        // }
        else if (name === 'startDate') {
            setFieldValue('endDate', addYearsAndSubtractOneDay(dayjs(value), 40).format("YYYY-MM-DD"));
            setEndDate(addYearsAndSubtractOneDay(dayjs(value), 40).format("YYYY-MM-DD"));
        }
        if (name !== 'startDate' && name !== 'endDate') {
            setTimeout(() => {
                validateField(name)
            }, 500);
        }
    }


    return (
        <FormikProvider value={formik}>
        <FormSchemaProvider schema={BankValidation}>
        <>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby={title}
                aria-describedby={'form-modal'}
            >
                <Box sx={{ ...style }}>
                    <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} flexDirection={'row'} borderBottom={`1px solid ${palette.text.secondary}B2`} padding={{ lg: '25px 30px', md: '25px 30px', sm: '15px 25px', xs: '15px 25px' }}>
                        <Typography id={title} variant="h2" fontSize={{ lg: '20px', md: '20px', sm: '16px', xs: '16px' }}>
                            {title}
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <BlackExitIcon />
                        </IconButton>
                    </Box>
                    <Box padding={'35px 30px 25px'} component={'div'} sx={{
                        overflowY: 'auto',
                        maxHeight: { sm: '80vh', xs: '80vh' },
                    }}>
                        {loading && <MandateFormSkeleton />}
                        {!loading && (
                            <>
                                <Box display={'flex'} flexDirection={'row'} gap={'10px'}>
                                    {radioList?.map((item) => (
                                        <Box key={item.id} component={'button'} display={'flex'} alignItems={'center'} gap={'10px'} borderRadius={'10px'} border={`1px solid ${palette.text.secondary}80`} padding={'10px 15px'} width={'fit-content'}
                                            sx={{ background: item.id === selectedRadio ? palette.primary[500] + '1A' : 'transparent', cursor: 'pointer' }}
                                            onClick={() => setSelectedRadio && setSelectedRadio(item.id)}>
                                            {item.id === selectedRadio ? <CheckedRadio /> : <UncheckRadio />}
                                            <Typography variant="body_500" fontSize={{ lg: '16px', md: '16px', sm: '14px', xs: '14px' }} color={item.id === selectedRadio ? palette.primary[500] : palette.text.secondary}>{item.label}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                                <Box sx={{ margin: '15px 0', borderTop: '.5px solid #CDCDCD', borderBottom: '.5px solid #CDCDCD' }}>

                                    <Grid container columnSpacing={4} rowSpacing={'45px'} padding={'45px 0'}>
                                        <Grid item lg={6} md={12} sm={12} xs={12}>
                                            <CustomeTextField label="Mandate Limit" symbol={true} type={'number'} name={'amount'} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange('amount', e.target.value)} value={values.amount} handleBlur={handleBlur} error={errors.amount} onKeyDown={(e) => {
                                                if (['-', '+', 'e', 'E'].includes(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }} />
                                        </Grid>
                                        <Grid item lg={6} md={12} sm={12} xs={12}>
                                            <CustomeModalDropDown name='accountNo' label="Bank Account Number" onChange={handleModalDropdown} data={bankAccountNumbers || []} value={values.accountNo} />
                                        </Grid>
                                        <Grid item lg={6} md={12} sm={12} xs={12}>
                                            <CustomeTextField label="Bank Sub Account Type" type={'text'} name={'bankSubAccountType'} onChange={() => { return }} value={`${BANK_SUB_ACCOUNT_TYPES[`${values?.bankSubAccountType ?? ""}`.toUpperCase()] ?? ""}`} disabled={true} />
                                        </Grid>
                                        <Grid item lg={6} md={12} sm={12} xs={12}>
                                            <CustomeTextField label="IFSC Code" type={'text'} name={'ifsc'} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange('ifsc', e.target.value)} value={values.ifscCode} handleBlur={handleBlur} error={errors.ifscCode} disabled={true} />
                                        </Grid>
                                        <Grid item lg={6} md={12} sm={12} xs={12}>
                                            <CustomeTextField label="Bank Name" type={'text'} name={'bankName'} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange('bankName', e.target.value)} value={values.bankName} handleBlur={handleBlur} error={errors.bankName} disabled={true} />
                                        </Grid>

                                        {/* Date Additions */}
                                        {/* Start Date */}
                                        <Grid item lg={6} md={12} sm={12} xs={12}>
                                            <FormControl fullWidth>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        label="Start Date"
                                                        value={dayjs(startDate)}
                                                        onChange={(date: any) => {
                                                            setStartDate(date?.format("YYYY-MM-DD") ?? dayjs(new Date()).format("YYYY-MM-DD"));
                                                            handleOnChange('startDate', date?.format("YYYY-MM-DD") ?? dayjs(new Date()).format("YYYY-MM-DD"));
                                                        }
                                                        }
                                                        slots={{
                                                            openPickerIcon: () => <CalendarIcon fillColor={theme.palette.primary[500]} />,
                                                        }}
                                                        format="DD/MM/YYYY"
                                                        views={['year', 'month', 'day']}
                                                        minDate={dayjs(new Date())}
                                                        sx={{
                                                            '&.MuiTextField-root': {
                                                                '& fieldset': {
                                                                    borderRadius: "10px",
                                                                    backgroundColor: `${theme.palette.common.white}0D`,
                                                                    border: `0.5px solid ${theme.palette.text.secondary}80`,
                                                                },
                                                                '.MuiInputBase-input': {
                                                                    ...theme.typography.body_500,
                                                                    letterSpacing: "0.32px",
                                                                    color: theme.palette.text.primary,
                                                                    padding: "10px"
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>

                                        {/* End Date */}

                                        <Grid item lg={6} md={12} sm={12} xs={12}>
                                            <FormControl fullWidth>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        label="End Date"
                                                        value={dayjs(endDate)}
                                                        onChange={(date: any) => {
                                                            setEndDate(date?.format("YYYY-MM-DD") ?? dayjs(new Date()).format("YYYY-MM-DD"));
                                                            handleOnChange('endDate', date?.format("YYYY-MM-DD") ?? dayjs(new Date()).format("YYYY-MM-DD"));
                                                        }
                                                        }
                                                        slots={{
                                                            openPickerIcon: () => <CalendarIcon fillColor={theme.palette.primary[500]} />,
                                                        }}
                                                        maxDate={dayjs(fortyYrsFromNow)}
                                                        format="DD/MM/YYYY"
                                                        views={['year', 'month', 'day']}
                                                        sx={{
                                                            '&.MuiTextField-root': {
                                                                '& fieldset': {
                                                                    borderRadius: "10px",
                                                                    backgroundColor: `${theme.palette.common.white}0D`,
                                                                    border: `0.5px solid ${theme.palette.text.secondary}80`,
                                                                },
                                                                '.MuiInputBase-input': {
                                                                    ...theme.typography.body_500,
                                                                    letterSpacing: "0.32px",
                                                                    color: theme.palette.text.primary,
                                                                    padding: "10px"
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>

                                        {/* <Grid item lg={6} md={12} sm={12} xs={12}>
                                    <CustomeTextField label="No. of Months" min={6} minlabel="6 Months" max={480} maxlabel="480 Months" type={'number'} name={'months'} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange('months', e.target.value)} value={values.months} handleBlur={handleBlur} error={errors.months} onKeyDown={(e) => {
                                        if (['.', '-', '+', 'e', 'E'].includes(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    />
                                </Grid> */}
                                    </Grid>


                                </Box>
                                <Box marginTop={'25px'} gap={'25px'} display={'flex'} flexDirection={'column'}>
                                    <Box>
                                        <Typography variant='subtitle_400' color={palette.text.secondary} fontSize={{ lg: '16px', md: '16px', sm: '14px', xs: '14px' }}>
                                            <Typography variant='body_500' fontWeight={600} color={palette.primary[500]} component={'span'}>Note: </Typography>
                                            {selectedRadio === radioList?.[0].id ? 'This is a Physical Mandate that requires printing, signing, and scanning. Verification with the bank usually takes 21 working days.' : `This is a Digital Mandate requiring the investor to use Netbanking Facility. They'll receive a link for a 1 Rupee payment from their bank account. Verification takes 2 working days. List of Allowed Banks is below.`}
                                        </Typography>
                                    </Box>
                                    {selectedRadio === radioList?.[1].id && (
                                        <Box display={'flex'} gap={'10px'} alignItems={'center'}>
                                            <PdfIcon />
                                            <Typography
                                                variant='overline_600'
                                                color={palette.primary[500]}
                                                sx={{
                                                    textTransform: 'capitalize',
                                                    cursor: 'pointer'
                                                }}
                                                // onClick={() => window.open((
                                                //     NEXEDGE_MDMS_APIS ?
                                                //         "https://nexedgewms.kfintech.com/api/mdms/list_of_allowed_banks.pdf"
                                                //         : "http://wmsdev.kfintech.com/mdms/list_of_allowed_banks.pdf"), '_blank'
                                                // )}
                                                onClick={() => window.open("https://www.npci.org.in/PDF/nach/live-members-e-mandates/API-Live-Sponsor-Bank.pdf")}
                                            >
                                                LIST OF ALLOWED BANKS
                                            </Typography>

                                        </Box>
                                    )}
                                    <Box>
                                        <CustomeButton lookType={'contained'} btnText={'Submit'} isLoading={isFormSubmitting} onClick={handleSubmit} />
                                    </Box>
                                </Box>
                            </>
                        )}
                    </Box>
                </Box>
            </Modal >
            <Dialog
                open={dialogPopup}
                maxWidth='sm'
                fullWidth
                sx={{
                    '& .MuiPaper-root': {
                        borderRadius: '15px',
                        backgroundColor: "background.paper",
                    },
                }}
            >
                <DialogContent sx={{ paddingTop: "24px" }}>
                    <Box sx={{ display: "flex", columnGap: "8px" }}>
                        <Typography variant='h2' color="text.primary" mb="10px">{'Mandate Request Sent'}</Typography>
                    </Box>

                    <Typography
                        component={'span'}
                        variant='subtitle_400'
                        color="text.secondary"
                        sx={{
                            lineHeight: "20px"
                        }}
                    >
                        {radioList[0].id === selectedRadio ? 'We have submitted the mandate request to the investor.' : 'We have submitted the mandate request to the BSE. Once approved, we can process with the SIP investment.'}
                    </Typography>
                </DialogContent>

                <DialogContent>
                    <Typography
                        component={'span'}
                        variant='body_500'
                        sx={(theme: Theme) => ({
                            lineHeight: "20px",
                            color: theme.palette.primary[500]
                        })}
                    >
                        {'Note:'}
                    </Typography>
                    <Typography
                        component={'span'}
                        variant='subtitle_400'
                        sx={(theme: Theme) => ({
                            lineHeight: "20px",
                            color: theme.palette.text.secondary,
                            fontSize: { lg: '16px', md: '16px', sm: '14px', xs: '14px' },
                        })}
                    >
                        {radioList[0].id === selectedRadio ? 'This is a Physical Mandate requiring the investor to print, sign, and upload the scanned version. Verification takes 21 working days with the bank.' : 'Until then, you can process with the Lumpsum investment.'}
                    </Typography>

                </DialogContent>

                <DialogActions sx={{ padding: "25px", columnGap: "10px" }}>
                    <Button
                        variant="contained"
                        sx={(theme: Theme) => ({
                            flex: 1,
                            color: theme.palette.textDark.primary,
                            padding: "10px",
                            fontSize: { lg: '14px', md: '14px', sm: '12px', xs: '12px' },
                        })}
                        onClick={() => {
                            handleClose()
                            handleSuccess && handleSuccess()
                            setDialogPopup(false)
                        }}
                    >
                        {'OK'}
                    </Button>
                </DialogActions>
            </Dialog>

        </>
        </FormSchemaProvider>
        </FormikProvider>
    )
}

export default AddBankModal


type CustomeTextFieldProps = {
    label: string,
    min?: number,
    minlabel?: string,
    max?: number
    maxlabel?: string
    symbol?: boolean
    type: string
    name: string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    value: string
    handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
    error?: string
    disabled?: boolean,
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
}


const CssTextField = styled(TextField)(({ theme, error }) => ({
    // height: '50px',
    '& label.Mui-focused': {
        color: `${error ? theme.palette.error.main : theme.palette.text.secondary}`,
        fontSize: { lg: '16px', md: '16px', sm: '14px', xs: '14px' },
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: `${error ? theme.palette.error.main : theme.palette.text.secondary}80`,
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: `${error ? theme.palette.error.main : theme.palette.text.secondary}80`,
            fontSize: { lg: '16px', md: '16px', sm: '14px', xs: '14px' },
        },
        '&:hover fieldset': {
            borderColor: `${error ? theme.palette.error.main : theme.palette.text.secondary}80`,
        },
        '&.Mui-focused fieldset': {
            borderColor: `${error ? theme.palette.error.main : theme.palette.text.secondary}80`,
        },
        '& .MuiTypography-body1': {
            color: `${theme.palette.text.primary}`,
        },
        color: `${theme.palette.text.primary}`,
        fontWeight: 500,
    },
}));

const CustomeTextField = (props: CustomeTextFieldProps) => {
    const { label, min, minlabel, max, maxlabel, symbol, type, name, onChange, value, handleBlur, error, disabled, onKeyDown } = props
    const { palette } = useTheme()
    const { currencySymbol } = useSelector((store: RootStateType) => store.currencyInfo);


    return (
        <Box>
            <CssTextField
                type={type}
                name={name}
                error={typeof error === 'string'}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e)}
                onBlur={(e: React.FocusEvent<HTMLInputElement>) => handleBlur && handleBlur(e)}
                onWheel={event => event.target instanceof HTMLElement && event.target.blur()}
                onPaste={e => e.preventDefault()}
                value={value}
                color='primary'
                defaultValue={' '}
                size='small'
                id="outlined-basic"
                label={label}
                variant="outlined"
                disabled={disabled}
                fullWidth
                InputProps={{
                    sx: {
                        borderRadius: '10px',
                        fontSize: { lg: '16px', md: '16px', sm: '14px', xs: '14px' },
                    },
                    startAdornment: symbol ? <InputAdornment position="start">{String.fromCharCode(parseInt(currencySymbol, 16))}</InputAdornment> : null
                }}
                onKeyDown={onKeyDown}
            />
            {typeof error === 'string' && error !== 'Required' && (
                <Box display={'flex'} flexDirection={'row'} gap={'20px'}>
                    <Typography variant="subtitle_500" fontSize={{ lg: '14px', md: '14px', sm: '12px', xs: '12px' }} color={palette.error[500]}>{error}</Typography>
                </Box>
            )}
            {min && max && (
                <Box display={'flex'} flexDirection={'row'} gap={'20px'}>
                    <Typography variant="subtitle_500" fontSize={{ lg: '14px', md: '14px', sm: '12px', xs: '12px' }} color={palette.text.primary}>Min: {minlabel}</Typography>
                    <Typography variant="subtitle_500" fontSize={{ lg: '14px', md: '14px', sm: '12px', xs: '12px' }} color={palette.text.primary}>Max: {maxlabel}</Typography>
                </Box>
            )}
        </Box>
    )
}

